import { useContext } from "react";
import "./dialog-styles.css";
import { StoryContext } from "../views/Game.tsx";
import {
  Cross2Icon,
  BookmarkFilledIcon,
  BookmarkIcon,
} from "@radix-ui/react-icons";
import * as Popover from "@radix-ui/react-popover";
import { Box } from "@radix-ui/themes";

function StoryDialog() {
  const [storyContext, setStoryContext] = useContext(StoryContext);

  return (
    <Box style={{ position: "fixed", left: "7px", top: "70px" }}>
      <Popover.Root
        open={storyContext.storyDialogOpen || false}
        onOpenChange={() => {
          setStoryContext({
            ...storyContext,
            storyDialogOpen: !storyContext.storyDialogOpen,
          });
        }}
      >
        {storyContext.storyDialogOpen && (
          <Popover.Trigger asChild>
            <button className="IconButton" aria-label="Story available">
              <BookmarkFilledIcon width={35} height={50} />
            </button>
          </Popover.Trigger>
        )}
        {!storyContext.storyDialogOpen && (
          <button className="IconButtonDisabled" aria-label="...">
            <BookmarkIcon width={35} height={50} />
          </button>
        )}
        {storyContext.storyDialogOpen && (
          <Popover.Portal>
            <Popover.Content className="PopoverContent" sideOffset={5}>
              <div>
                <span
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    margin: "10px",
                    color: "var(--ro-text)" /* Gold highlight color */,
                  }}
                >
                  {storyContext.storyTitle}
                </span>
                <div
                  style={{
                    display: "block",
                    height: "300px",
                    overflowY: "scroll",
                    margin: "10px",
                    color: "var(--ro-text)" /* Gold highlight color */,
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {storyContext.storyText}
                </div>
              </div>
              <Popover.Close className="PopoverClose" aria-label="Close">
                <Cross2Icon />
              </Popover.Close>
              <Popover.Arrow className="PopoverArrow" />
            </Popover.Content>
          </Popover.Portal>
        )}
      </Popover.Root>
    </Box>
  );
}

export default StoryDialog;
